<template>
  <v-container fluid>
    <v-row justify-md="space-between" v-if="![3].includes(Role)">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir enlace
        </v-btn>
      </v-col>
    </v-row>

    <br />

    <!-- :search="search" -->
    <v-data-table
      show-expand
      single-expand
      :headers="headers"
      :items="FormlinksList"
      item-key="id"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100],
      }"
    >
      <!-- <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template> -->

      <template v-slot:expanded-item="{ item }">
        <td colspan="100%">
          <v-row dense no-gutters class="w-100">
            <v-col
              cols="12"
              class="py-4"
            >
              <v-row class="pl-10">
                <v-col cols="12" class="py-2">
                  <h5 class="text-subtitle-2 pb-0 my-0 primary--text">
                    Descripción
                  </h5>
                </v-col>

                <v-col cols="12" class="pl-3 py-0">
                  <p class="my-0">
                    {{ item.description }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-slot:[`item.type`]="{ item }">
        {{ item.type === 0 ? "Interno" : "Externo" }} 
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-hover v-if="[3].includes(Role)" v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleOpen(item)"
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-if="![3].includes(Role)" v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'accent' : 'blue-grey'"
            @click.stop="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-hover>

        <v-hover v-if="![3].includes(Role)" v-slot:default="{ hover }">
          <v-btn
            text
            icon
            :color="hover ? 'error' : 'blue-grey'"
            @click.stop="handleDelete(item)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-hover>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogOpen" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">Enlace Interno</span>
      </v-card-title>
      <v-card-text>
        <iframe :src="iframeUrl" width="100%" height="600px"></iframe>
      </v-card-text>

      <v-card-actions>
          <v-btn
            @click="closeDialogOpen()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
  </v-dialog>

    <btnregister
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></btnregister>
  </v-container>
</template>

<script>
import axios from "axios";
import btnregister from "./btnregister.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';

export default {
  components: {
    btnregister,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    dialogOpen: false,  // Controlar el diálogo para iframe
    iframeUrl: "",      // URL para el iframe
    FormlinksList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "URL",
        align: "left",
        value: "url",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Tipo de enlace",
        align: "left",
        value: "type",
        class: "primary--text",
        width: "25%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getFormLinksList();
      },
      deep: true,
    },
  },

  computed: {
    // Clients() {
    //   return this.$store.getters["clients/GET_ALL_CLIENTS"];
    // },

    // getClientName() {
    //   return (clientId) => {
    //     const client = this.Clients.find(c => c.id === clientId);
    //     return client ? client.name : "Desconocido"; // Retorna el nombre o un valor por defecto
    //   };
    // }
    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },
  },

  created() {
    this.getFormLinksList();
  },

  methods: {
    openFormDialog() {
      this.isOpenForm = true;
    },

    closeDialogOpen() {
      this.dialogOpen = false;
    },

    handleOpen(item) {
      let url = item.url.startsWith("http") ? item.url : `https://${item.url}`;

      if (item.type === 1) {
        window.open(url, "_blank");
      } else if (item.type === 0) {
        this.iframeUrl = url;
        this.dialogOpen = true;
      }
    },

    // async GetClients() {
    //   try {
    //     const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
    //     this.data = response.data;
    //     this.isLoadingClients = false;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar esta configuración de variables? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          axios
            .delete(
              `${process.env.VUE_APP_ROOTAPI}/external/external_links/${event.id}`,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res) => {
              this.getFormLinksList();
              this.$snotify.success("Configuración eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error(
                "Hubo un error al eliminar esta configuración.",
                "Error"
              );
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la configuración.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.FormlinksList = this.FormlinksList.map(
          (el) => (el.id === data.id ? data : el)
        );
      if (data && !this.isEditMode)
        this.FormlinksList = [
          ...this.FormlinksList,
          data,
        ];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    getFormLinksList() {
      this.isLoading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/external/external_links`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page,
            itemPerPage: itemsPerPage,
            // type: this.searchType,
            // value: this.search,
          },
        })
        .then((res) => {
          this.FormlinksList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
